<script lang="ts" setup>
import { computed, reactive, shallowRef } from 'vue'

import { hexToRgb, isColorTooBright } from './utils/color'

import FortuneWheel from './Mechanics/FortuneWheel.vue'
import MysteryBox from './Mechanics/MysteryBox.vue'
import ScratchCard from './Mechanics/ScratchCard.vue'

import type {
  ContestColor,
  ContestGameReward,
  FormattedContestGameReward,
  GameContest,
  Merchant,
} from './contestGame'

const emit = defineEmits<{
  (e: 'completed'): void
  (e: 'loading'): void
}>()
const props = withDefaults(
  defineProps<{
    contestColor: ContestColor
    contestGame: GameContest
    contestGameRewards: FormattedContestGameReward[]
    contestReward: ContestGameReward
    coverImage: string
    logo: string
    mechanic: 'mysteryBox' | 'fortuneWheel' | 'scratchCard'
    merchant: Merchant
    modelValue: boolean
    webAppUrl: string
  }>(),
  {
    mechanic: 'scratchCard',
  },
)

const components = reactive({
  mysteryBox: {
    componentName: shallowRef(MysteryBox),
  },
  fortuneWheel: {
    componentName: shallowRef(FortuneWheel),
  },
  scratchCard: {
    componentName: shallowRef(ScratchCard),
  },
})

const contestComponent = computed(() => {
  return components[props.mechanic].componentName
})

const color = computed(() => {
  const baseColor = isColorTooBright(props.contestColor.backgroundColor)
    ? props.contestColor.buttonColor
    : props.contestColor.backgroundColor

  return {
    ...props.contestColor,
    fromColor: hexToRgb(baseColor, 20),
    toColor: hexToRgb(baseColor, 40),
  }
})

const onCompleted = () => {
  emit('completed')
}
</script>

<template>
  <div class="relative z-10 h-full w-full">
    <component
      :is="contestComponent"
      :color="color"
      :contest-game="contestGame"
      :cover-image="coverImage"
      :logo="logo"
      :merchant="merchant"
      :model-value="modelValue"
      :reward="contestReward"
      :rewards="contestGameRewards"
      :web-app-url="webAppUrl"
      @loading="emit('loading')"
      @completed="onCompleted"
    />
  </div>
</template>
